import { CALENDAR_GRID_EMPTY_COUNT } from '../CalendarGrid.constants'
import { getIsCalendarGridDayFull } from '../CalendarGrid.utils'

import {
  CALENDAR_GRID_DAY_CHIP_LIMIT,
  CALENDAR_GRID_DAY_LOAD_CHIP_COUNT,
} from './CalendarGridDayChips.constants'

function getCalendarGridLaneItems({ dayLoad, items }) {
  return getIsCalendarGridDayFull(dayLoad)
    ? items.filter(item => !item.isCountedInDayLoad)
    : items
}

function getCalendarGridReservedChipCount(dayLoad) {
  return getIsCalendarGridDayFull(dayLoad)
    ? CALENDAR_GRID_DAY_LOAD_CHIP_COUNT
    : CALENDAR_GRID_EMPTY_COUNT
}

export function getCalendarGridDayChips({ dayLoad, items, spanCount }) {
  return getCalendarGridLaneItems({ dayLoad, items }).slice(
    0,
    Math.max(
      CALENDAR_GRID_EMPTY_COUNT,
      CALENDAR_GRID_DAY_CHIP_LIMIT -
        getCalendarGridReservedChipCount(dayLoad) -
        spanCount
    )
  )
}

export function getCalendarGridDayOverflowCount({ dayLoad, items, spanCount }) {
  return (
    getCalendarGridLaneItems({ dayLoad, items }).length -
    getCalendarGridDayChips({ dayLoad, items, spanCount }).length
  )
}

export function getHasCalendarGridDayOverflow(overflowCount) {
  return overflowCount > CALENDAR_GRID_EMPTY_COUNT
}

export function getCalendarGridDayLoadItems(items) {
  return items.filter(item => item.isCountedInDayLoad)
}
